import React from "react"
import shape1 from "../../images/our-mission/our-mission-shape1.png"
import { getBackgroundClass, getLayoutClass } from "../../utils/sectionHelpers";
import DynamicImage from "../common/DynamicImage";
import { renderText } from "../common/renderText";
import { HighlightText } from "../common/HighlightText";

const MissionList = ({ data }) => {
  const settings = data?.Settings || {};

  const backgroundClass = getBackgroundClass(settings.background);
  const layoutClass = getLayoutClass(settings.layout);

  return (
    <>
      <div className={`our-mission-area ptb-70 ${backgroundClass}`}>
        <div className="container">
          <div className="row justify-content-center mb-3">
            <div className="col-lg-9" data-aos="fade-up" data-aos-duration="1200">
              <div className="content text-start text-lg-center">
                {/* <h2>{data?.title}</h2>
                {data?.description?.map((block, index) => {
                  if (block.type === "paragraph") {
                    return (
                      <p key={index}>
                        {block.children.map((child) => child.text).join("")}
                      </p>
                    );
                  }
                  return null;
                })} */}

                {data?.secTitle?.map((block, index) => {
                  switch (block.type) {
                    case "paragraph":
                      return (
                        <p key={index} className="mb-0">
                          {block.children.map((child, i) => {
                            let textElement = child.text;

                            if (child.bold) {
                              textElement = <strong>{textElement}</strong>;
                            }

                            if (child.italic) {
                              textElement = <em>{textElement}</em>;
                            }

                            if (child.underline) {
                              textElement = <u>{textElement}</u>;
                            }

                            if (child.strikethrough) {
                              textElement = <s>{textElement}</s>;
                            }

                            return <React.Fragment key={i}>{textElement}</React.Fragment>;
                          })}
                        </p>

                      );

                    case "heading":
                      const Tag = `h${block.level}`;
                      return (
                        <Tag key={index} className="mt-4 mb-3">
                          <HighlightText content={block.children.map(c => c.text).join("")} />
                        </Tag>
                      );

                    case "list":
                      return (
                        <ul key={index} className="list-unstyled">
                          {block.children.map((item, i) => (
                            <li key={i} className="features-text">
                              <h4>
                                <i className="flaticon-tick"></i>{" "}
                                {item.children.map(c => c.text).join("")}
                              </h4>
                            </li>
                          ))}
                        </ul>
                      );

                    default:
                      return null;
                  }
                })}
              </div>
            </div>
          </div>
          <div className={`row align-items-center gx-lg-5 ${layoutClass}`}>
            <div className="col-lg-6 col-md-12 order-lg-2 order-1" data-aos="fade-up" data-aos-duration="1200">
              <div className="our-mission-content mt-0">
                <div className="content text-start">
                  <h2>
                    <HighlightText content={data.title} />
                  </h2>

                  {data?.description?.map((block, index) => {
                    switch (block.type) {
                      case "paragraph":
                        return (
                          <p key={index} className="mb-0">{renderText(block.children)}</p>

                        );

                      case "heading":
                        const Tag = `h${block.level}`;
                        return (
                          <Tag key={index} className="mt-4 mb-3">
                            <HighlightText content={block.children.map(c => c.text).join("")} />
                          </Tag>
                        );

                      case "list":
                        return (
                          <ul key={index} className="features-list">
                            {block.children.map((item, i) => (
                              <li key={i}>
                                <i className="flaticon-tick"></i>{" "}
                                {item.children.map(c => c.text).join("")}
                              </li>
                            ))}
                          </ul>
                        );
                      default:
                        return null;
                    }
                  })}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 order-lg-1 order-2" data-aos="fade-up" data-aos-duration="1200">
              <div className="our-mission-image">
                <DynamicImage image={data.image} />
                <div className="shape">
                  <img src={shape1} alt="shape" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MissionList
